import { render, staticRenderFns } from "./MyAddressBook.vue?vue&type=template&id=8d400662&"
import script from "./MyAddressBook.vue?vue&type=script&lang=js&"
export * from "./MyAddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports